export const klipfolioSameAs = [
  "https://twitter.com/klipfolio",
  "https://www.facebook.com/Klipfolio",
  "https://www.linkedin.com/company/klipfolio",
  "https://www.instagram.com/klipfolio/",
  "https://www.youtube.com/klipfolio",
  "https://en.wikipedia.org/wiki/Klipfolio_dashboard",
  "https://www.wikidata.org/wiki/Q6421108",
  "https://www.crunchbase.com/organization/klipfolio",
]

export const klipfolioAuthor = siteMetadata => {
  return {
    url: siteMetadata?.siteUrl,
    name: "Klipfolio.com",
    "@type": "Organization",
    sameAs: klipfolioSameAs,
  }
}

export const customAuthor = (author, siteMetadata) => {
  return {
    url: author.linkedin ?? siteMetadata?.siteUrl,
    name: author.name,
    "@type": "Person",
  }
}

export const klipfolioPublisher = {
  logo: {
    url: "https://www.klipfolio.com/sites/all/themes/klipfolio_theme/img/brand/kf-icon.png",
    "@type": "ImageObject",
    width: "600",
    height: "600",
  },
  name: "Klipfolio",
  "@type": "Organization",
  sameAs: klipfolioSameAs,
}
